import { Role } from '@/Enums/Users/Role.enum';
import {
  ADMIN_USER_ROLE_OPTIONS,
  ORG_ADMIN_ADMIN_USER_ROLE_OPTIONS,
  USER_FILTER_TO_USER_ROLE,
  WHITELABEL_ADMIN_USER_ROLE_OPTIONS,
} from '@/constants/userManagement';

export const isAdminRole = userRole => {
  return [Role.ADMIN, Role.ORG_ADMIN, Role.WHITELABEL_ADMIN].includes(+userRole);
};

export const isSuperAdminRole = userRole => +userRole === Role.ADMIN;
export const isOrgAdminRole = userRole => +userRole === Role.ORG_ADMIN;
export const isWhitelabelAdminRole = userRole => +userRole === Role.WHITELABEL_ADMIN;
export const isClientRole = userRole => +userRole === Role.CLIENT;
export const isAgencyRole = userRole => +userRole === Role.AGENCY;
export const isAdvertiserRole = userRole => +userRole === Role.ADVERTISER;

// Client / Agency / Advertiser are the "restricted tier" per #4444's access
// grid: wholesale Spend/CPM and DSP/Platform are never available to these
// targets, with no admin override — unlike Org Admin / Whitelabel Admin
// where the same two toggles are off-by-default but overridable.
export const isRestrictedAccessRole = userRole => [Role.CLIENT, Role.AGENCY, Role.ADVERTISER].includes(+userRole);

export const getUserRoleFilter = filter => {
  if (!filter) return null;
  const setFilters = [];
  Object.entries(filter).forEach(([type, value]) => value && setFilters.push(USER_FILTER_TO_USER_ROLE[type]));
  return setFilters.flat();
};

const ALLOWED_USER_ROLE_OPTIONS = {
  [Role.ADMIN]: ADMIN_USER_ROLE_OPTIONS,
  [Role.ORG_ADMIN]: ORG_ADMIN_ADMIN_USER_ROLE_OPTIONS,
  [Role.WHITELABEL_ADMIN]: WHITELABEL_ADMIN_USER_ROLE_OPTIONS,
};

export const getAllowedUserRoleOptions = userRole => {
  return ALLOWED_USER_ROLE_OPTIONS[userRole] ?? [];
};

export const isRoleAllowedCpm = userRole => {
  return ![Role.ADVERTISER, Role.AGENCY].includes(userRole);
};

export const isRoleAllowedClientSelect = userRole => {
  return ![Role.ADVERTISER, Role.AGENCY].includes(userRole);
};

export const isRoleAllowedWhitelabelSelect = userRole => {
  return [Role.ADMIN, Role.ORG_ADMIN].includes(userRole);
};

export const isRoleAllowedRateCardDimension = userRole => {
  return [Role.ORG_ADMIN, Role.WHITELABEL_ADMIN, Role.CLIENT].includes(userRole);
};

export const isRoleAllowedWhitelabelsEndpoint = userRole => {
  return [Role.ADMIN, Role.ORG_ADMIN, Role.WHITELABEL_ADMIN, Role.CLIENT].includes(userRole);
};
